<template>
  <div class="page">
    <el-form :model="form" label-width="100px" :rules="rules" ref="ruleForm">
      <el-form-item label="姓名：" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="电话：" prop="phone">
        <el-input v-model="form.phone">
          <el-button slot="append" @click="sendCode">{{ codeStr }}</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="验证码：" prop="code">
        <el-input v-model="form.code"></el-input>
      </el-form-item>
      <el-form-item label="证件类型：" prop="certType">
        <el-select
          v-model="form.certType"
          placeholder="请选择证件类型"
          style="width: 100%"
        >
          <el-option label="身份证" value="身份证"></el-option>
          <el-option label="工作证" value="工作证"></el-option>
          <el-option label="护照" value="护照"></el-option>
          <el-option label="统一社会信用代码" value="统一社会信用代码"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件号码：" prop="certNum">
        <el-input v-model="form.certNum"></el-input>
      </el-form-item>
      <el-form-item label="房号：" prop="houseName">
        <el-autocomplete
          ref="searchInput"
          style="width: 100%"
          class="inline-input"
          v-model="form.houseName"
          :fetch-suggestions="querySearch"
          placeholder="请输入房号搜索并选择房间"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="queryAreas(form.houseName)"
          ></el-button>
        </el-autocomplete>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="onSubmit" style="width: 70%"
      >提交</el-button
    >
  </div>
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import { Loading } from "element-ui";
import wx from "weixin-js-sdk";

export default {
  name: "home",

  data() {
    return {
      form: {
        certType: "身份证"
      },

      areasList: [],
      areasMap: new Map(),

      codeStr: "获取",
      time: 0,

      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入电话号码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        certType: [
          { required: true, message: "请选择证件类型", trigger: "blur" }
        ],
        certNum: [
          { required: true, message: "请输入证件号码", trigger: "blur" }
        ],
        houseName: [{ required: true, message: "请选择房号", trigger: "blur" }]
      }
    };
  },

  created() {
    Utils.userInfo.userID = this.$route.query.userID;
    Utils.userInfo.openID = this.$route.query.openID;

    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", this.$route.query.client || "");

    this.form = {
      certType: "身份证",
      openID: this.$route.query.openID
    };

    document.title = "绑定合同";
  },

  methods: {
    querySearch(queryString, cb) {
      cb(this.areasList);
    },

    sendCode() {
      if (this.form.phone.length <= 0 || this.time > 0) {
        return;
      }
      let url = axios.defaults.baseURL + "users/smscodes/send";
      url = url.replace("/org", "");
      url = url.replace("10241", "10242");

      let _vue = this;

      axios({
        method: "post",
        url: url,
        data: {
          phone: this.form.phone
        }
      })
        .then(value => {
          if (value && value.data && value.data.code === 0) {
            this.time = 60;
            let interval = setInterval(function() {
              _vue.time--;
              _vue.codeStr = `${_vue.time}s`;
              if (_vue.time <= 0) {
                _vue.codeStr = "获取";
                clearInterval(interval);
              }
            }, 1000);
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {
          this.$message.error("获取验证码失败");
        });
    },

    queryAreas(query) {
      if (!query) {
        this.$message.warning("请输入房号搜索");
        return;
      }
      let url = axios.defaults.baseURL + "users/areas/list";
      url = url.replace("/org", "");
      url = url.replace("10241", "10242");
      axios({
        method: "post",
        url: url,
        data: {
          houseNameRegex: query,
          pageIdx: 0,
          pageSize: 100,
        }
      })
        .then(value => {
          if (value && value.data && value.data.data) {
            this.areasList = [];
            value.data.data.forEach(item => {
              item.value = item.areaName + item.name;
              item.address = item.id;
              this.areasList.push(item);
              this.areasMap.set(item.value, item.address);
              this.$refs.searchInput.focus();
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          if (this.areasList.length === 0) {
            this.$message.error("无数据");
          }
        });
    },

    onSubmit() {
      if (!this.areasMap.has(this.form.houseName)) {
        this.$message.error("请输入房号搜索并选择房间");
        return;
      }
      this.form.houseID = this.areasMap.get(this.form.houseName);

      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let url = axios.defaults.baseURL + "users/leases/bind";
          url = url.replace("/org", "");
          url = url.replace("10241", "10242");

          const loading = Loading.service({
            lock: true,
            text: "提交中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.1)"
          });

          axios({
            method: "post",
            url: url,
            data: this.form
          })
            .then(value => {
              if (value.data.code === 0) {
                this.$message.success(value.data.message);
                // 微信小程序
                wx.miniProgram.getEnv(function() {
                  // wx.miniProgram.navigateBack();
                  wx.miniProgram.reLaunch({
                    url: '/pages/index/index?relogin=true' // 绑定合同之后，通过relogin参数通知小程序重新登录
                  });
                });
              } else {
                this.$message.error(value.data.message);
              }
            })
            .catch(() => {})
            .finally(() => {
              loading.close();
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style>
/*最小屏幕分辨率为1080px*/
@media screen and (max-width: 600px) {
  .el-message-box__wrapper {
    position: fixed;
    top: 30px;
    bottom: 0;
    left: 15px;
    right: 15px;
    text-align: center;
  }
  .el-message-box {
    width: 88% !important;
  }
}
</style>

<style lang="scss" scoped>
.page {
  padding: 15px;
  box-sizing: border-box;
}
.table-empty {
  margin-top: 200px;
}
header {
  background: white;
  position: sticky;
  top: 0;
  left: 0;
  align-items: center;
  box-sizing: border-box;
  display: flex;
  width: 100%;
  justify-content: space-around;
  border-bottom: 1px gray solid;
}
.main {
  justify-content: space-between;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  height: 160px;
}
.info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  div {
    margin-top: 8px;
  }
}
</style>
